<script>
/**
 * Descripción: Pantalla de error 404
 *
 * @displayName NotFoundViewComponent
 */

const TheError = () => import('@/components/core/layouts/TheError.vue');

export default {
  name: 'NotFoundViewComponent',

  components: {
    TheError
  }
};
</script>

<template>
  <TheError>
    <div slot="Img">
      <v-img src="@/assets/Not_found.svg" max-height="580" max-width="580" />
    </div>

    <div slot="RenderBody">
      <h1 class="display-2" style="color:#2c3e50;">¡Ups!, 404</h1>
      <br />
      <v-btn to="/" color="#2c3e50" outlined>¡Sácame de aquí!</v-btn>
    </div>
  </TheError>
</template>
